module.exports = __webpack_public_path__ + "static/img/banner.fe06a8bd.png";